import { z } from 'zod';

import { Entity } from './entity-schema';

const resolveSchema = z.object({
  input: z.string(),
  tag: z.string(),
});

const resolveV3Schema = z.object({
  input: z.string(),
  tags: z.array(z.string()).optional(),
});

const assetsResolveSchema = z.object({
  assets: z.array(resolveSchema),
});
const assetsResolveV3Schema = z.object({
  assets: z.array(resolveV3Schema),
});
export type AssetResolved = z.infer<typeof resolveSchema>;
export type AssetsResolverCSV = z.infer<typeof assetsResolveSchema>;
export type AssetsResolverV3CSV = z.infer<typeof assetsResolveV3Schema>;

export type EntityResolved = Entity & {
  input: string;
};

export type EntityNotResolved = Partial<Entity> & {
  input: string;
};

export type AllEntitiesResolved = EntityResolved | EntityNotResolved;

export const entities = {
  entity: { path: 'entity/v2/filtered' },
  searchEntities: {
    path: 'entity/v3/search/entities',
  },
  searchCurrencies: {
    path: 'entity/v3/search/currencies',
  },
  searchEconomies: {
    path: 'entity/v3/search/economies',
  },
  //V2
  resolveFromCsvV2: {
    path: 'entity-resolver/v2/csv',
    schema: assetsResolveSchema,
  },
  resolveFromCsvV3: {
    path: 'entity-resolver/v3/csv',
    schema: assetsResolveV3Schema,
  },
  searchEntityAndEconomies: {
    path: 'entity/v3/search/entities-economy',
  },
  entityLookup: { path: `entity/v3/lookup` },
} as const;
